import { useCurrentOverlay } from "shared/context/overlay/OverlayIDContext"

import { useProjectPermissions } from "entities/projects/model/useProjectPermissions"
import { readonlyProjectPermissions } from "entities/projects/types/ProjectPermissions"
import { useFloorActionHandlers } from "features/floor-management/model/useFloorActionHandlers"

import { FloorActionsOverlayPayload } from "../FloorActionsOverlay"

export function useFloorActionsOverlayViewModel({
  projectID,
  floorID
}: FloorActionsOverlayPayload) {
  const { closeOverlay } = useCurrentOverlay()
  const { permissions } = useProjectPermissions({ projectID })
  const handlers = useFloorActionHandlers({
    projectID,
    floorID,
    permissions: permissions ?? readonlyProjectPermissions,
    onAction: closeOverlay
  })

  return {
    ...handlers,
    closeOverlay
  }
}
